export type Tprops = { label: string; value: string };

export const InfoRow = (props: Tprops) => {
  return (
    <div className='flex-col w-1/2 py-2'>
      <p className='body-13-bold leading-[22.45px] text-disableText'>{props.label}</p>
      <p className='h5-bold leading-[22.45px] text-text'>{props.value || '-'}</p>
    </div>
  );
};

export const InfoRowFull = (props: Tprops) => (
  <div className='flex flex-col w-full py-2'>
    <p className='body-13-bold leading-[22.45px] text-disableText'>{props.label}</p>
    <p className='h5-bold leading-[22.45px] text-text'>{props.value || '-'}</p>
  </div>
);

export const DesktopRow = ({ children }: { children: React.ReactNode }) => (
  <div className='flex items-start justify-start gap-6 mb-6'>{children}</div>
);

export const DesktopInfoItem = ({
  label,
  value,
  width = 'w-[100%]',
}: {
  label: string;
  value: React.ReactNode;
  width?: string;
}) => (
  <div className={`flex flex-col gap-1 ${width} h-[49px]`}>
    <div className='text-gray body-12-bold'>{label}</div>
    <div className='text-text body-14-bold !leading-[24px]'>{value || '-'}</div>
  </div>
);
